import { useLanguageTranslator } from "hooks/use-language-translator";
import styles from "./styles.module.scss";

export const Tabs = ({ activeTab, setActiveTab, tabsArr }) => {
  const { translator } = useLanguageTranslator();

  function handleClickTab(tab) {
    setActiveTab(tab.key);
  }

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabs}>
        {tabsArr.map((tab) => (
          <div
            className={`
  ${styles[tab.key === activeTab ? "activeSingleTab" : "singleTab"]}
  
`}
            key={tab.key}
            onClick={() => handleClickTab(tab)}
          >
            {translator(`${tab.key}`)}
          </div>
        ))}
      </div>
    </div>
  );
};
